import { gql } from "@apollo/client";

export const GET_CLIENTES = gql`
  query allPlanesClientes( 
    $skip: Int
    $take: Int
    $where: Clientes_IFilterInput)
   {
    allPlanesClientes (skip: $skip, take: $take, where: $where){
      items{
        cod_Cliente
        nom_com
        condicionpago
        cUIT
        domicilio
        cP
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }  
  }
`;